import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const TableHeader = ({...props}) => {

  return (
    <TableHead
      style={{ position: "sticky", top: "0", backgroundColor: "#001753", zIndex: 100 }}
      >
      <TableRow>
        <TableCell align="right" style={{ color: "white", width: '90px'  }}>
        </TableCell>
        <TableCell align="right" style={{ color: "white", width: '90px'  }}>
          Id
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: '90px'  }}>
          Client
        </TableCell>
        <TableCell align="right" style={{ color: "white" }}>
          Date
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "150px" }}>
          Status
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "100px" }}>
          Total price
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "100px" }}>
          Change status
        </TableCell>
        <TableCell align="center" style={{ color: "white", width: "100px" }}>
          Delete Order
        </TableCell>
      </TableRow>
    </TableHead>    
  );
};

export default TableHeader;
